"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* English language bundle */
var _default = {
  $: {
    code: 'en',
    name: 'English'
  },
  keyboard: {
    // the localization keys are meaningful in react-simple-keyboard
    //
    // we previously used the official unicode ⇐ character, but some versions of Chrome in the kiosk don't render it correctly
    '{bksp}': '⇐',
    '{lock}': '⇪',
    '{shift}': '⇧',
    '{tab}': 'Next'
  }
};
exports["default"] = _default;